import { emojiGQLFields } from './emoji.fields.js';
import { imageGQLFields } from './image.fields.js';
const BASIC_MEDIA_FIELDS = {
    onImage: 'basic',
    onEmoji: 'basic',
};
const ALL_MEDIA_FIELDS = {
    onImage: 'all',
    onEmoji: 'all',
};
export function mediaGQLFields(fields = 'basic') {
    if (fields === 'basic')
        fields = BASIC_MEDIA_FIELDS;
    if (fields === 'all')
        fields = ALL_MEDIA_FIELDS;
    return `
      ... on Image {
        ${imageGQLFields()}
      }
      ... on Emoji {
        ${emojiGQLFields()}
      }
      ... on File {
        id
        name
        url
      }
  `;
}
//# sourceMappingURL=media.fields.js.map